<mat-stepper [linear]="true" #stepper (selectionChange)="stepChanged($event)">
    <mat-step *ngFor="let index of steps">
        <ng-template matStepLabel>{{index}}</ng-template>
        <app-dynamic-step *ngIf="step && index === step.title" [parent]="this" [sequence]="step.sequence" [title]="index" [step]="step"></app-dynamic-step>
    </mat-step>
</mat-stepper>
